// extracted by mini-css-extract-plugin
export default {"rowsHeader":"FacebookPage_rowsHeader__eLmFw","pageName":"FacebookPage_pageName__4fYKZ","metrics":"FacebookPage_metrics__rxobB","valueTitle":"FacebookPage_valueTitle__B42Fi"};